import { render, staticRenderFns } from "./NlpCheckAddressBackground2.vue?vue&type=template&id=cbb2d844"
import script from "./NlpCheckAddressBackground2.vue?vue&type=script&lang=js"
export * from "./NlpCheckAddressBackground2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports